import links from '@app/consts/links.json'

interface LinksConfigProps {
  links: typeof links
}

export const useLinksConfig = (): LinksConfigProps => {
  return {
    links,
  }
}
